// HumanityClub
import React from 'react';
import Humanity2023 from 'views/Humanity2023';

const HumanityClubPage = () => {
  return <Humanity2023 />;
};

export default HumanityClubPage;
